// extracted by mini-css-extract-plugin
module.exports = {"button":"_16SjC","text":"_1zj-W","active":"_2IFf0"};